"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromise = exports.isFunction = void 0;
/**
 * Check if a reference is a function.
 */
var isFunction = function (obj) { return typeof obj === 'function'; };
exports.isFunction = isFunction;
/**
 * Check if a reference is a Promise.
 */
var isPromise = function (obj) { return obj instanceof Promise; };
exports.isPromise = isPromise;
